import { ECategory } from 'shared/types/offers';

export const getBuildingStatus = (category: ECategory): string => {
  if (category === 'newBuildingFlatSale') {
    return 'новостройка';
  }

  return 'вторичка';
};
